import styled, { css } from 'styled-components';

import {
  colors,
  typography,
} from '../../theme';

import {
  TagBox,
} from '../../elements';

export const Wrapper = styled.div`
  background: ;
  bottom: 3rem;
  left: 0;
  opacity: 0;
  position: fixed;
  right: 0;
  top: 0;
  transition: opacity .5s ease-in-out,
              visibility .5s ease-in-out;
  visibility: hidden;
  z-index: 999;

  ${(props) => props.active && css`
    opacity: 1;
    visibility: visible;
  `}
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  left: 0;
  padding: ${10 / typography.BASE_FONT_SIZE}rem;
  position: absolute;
  right: 0;
  top: 0;
`;

export const Progress = styled.div`
`;

export const Title = styled.div`
`;

export const Caption = styled.div`
  bottom: 0;
  left: 0;
  padding: ${10 / typography.BASE_FONT_SIZE}rem;
  position: absolute;
  right: 0;
`;

export const Box = TagBox.withComponent('a');

export const CloseButton = Box.extend`
  ${typography.BODY__SMALL}
  background: ${colors.GREY__WHITE};
  color: ${colors.BLACK};
  text-decoration: none;
  ${typography.TAGBOX}
  transition: background .2s linear;
  position: relative;
  z-index: 2;

  &:hover {
    background: ${colors.WHITE};
  }
`;

export const Nav = styled.div`
  bottom: 0;
  display: flex;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

export const NavButton = styled.a`
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  ${(props) => props.prev && css`
    cursor: w-resize;
    flex-grow: 0;
    width: 25%;
  `}

  ${(props) => props.next && css`
    cursor: e-resize;
    flex-grow: 0;
    width: 25%;
  `}

  ${(props) => props.close && css`
    cursor: zoom-out;
    flex-grow: 1;
    width: 50%;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/IntroSlideshow/style.js